var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11C1 13.2091 2.79086 15 5 15H5.41055L6.40112 19.7052C6.68137 21.0364 8.18011 21.7054 9.35822 21.0252L11 20.0774C11.6188 19.7201 12 19.0598 12 18.3453V15.8052C13.4117 16.2828 14.7542 16.9673 15.9815 17.8439L18.605 19.7179C18.8619 19.9014 19.1697 20 19.4854 20C20.3219 20 21 19.3219 21 18.4854V3.51462C21 2.67812 20.3219 2 19.4854 2C19.1697 2 18.8619 2.09864 18.605 2.28212L15.9815 4.1561C13.392 6.00571 10.2894 7 7.10717 7H5C2.79086 7 1 8.79086 1 11ZM17.1439 5.78357L19 4.45781V17.5422L17.1439 16.2164C14.2153 14.1245 10.7062 13 7.10717 13H5C3.89543 13 3 12.1046 3 11C3 9.89543 3.89543 9 5 9H7.10717C10.7062 9 14.2153 7.87546 17.1439 5.78357ZM10 15.2766C9.16442 15.1153 8.3133 15.0235 7.45522 15.004L8.35822 19.2932L10 18.3453V15.2766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTone);
export default __webpack_public_path__ + "static/media/icon-tone.6d2b18c5f4ffd2fb0c7def536b9290e9.svg";
export { ForwardRef as ReactComponent };